import { render, staticRenderFns } from "./miniTab.vue?vue&type=template&id=8d88e19e&scoped=true&"
import script from "./miniTab.vue?vue&type=script&lang=js&"
export * from "./miniTab.vue?vue&type=script&lang=js&"
import style0 from "./miniTab.vue?vue&type=style&index=0&id=8d88e19e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d88e19e",
  null
  
)

export default component.exports